import type { GetKimMHOReportResponseDTO } from '@/core/dto/kim-mho';
import type { KimMHO } from '@/types/KimMHO';
import { KIM_MHO_RISKS } from '@/utils/constants';

export class KimMhoReportMapper {
	constructor(private readonly data: GetKimMHOReportResponseDTO) {}

	private getResult(): number {
		const riskIndex = Object.keys(KIM_MHO_RISKS).findIndex((key) => key === this.data.risk_load);
		const result = riskIndex + 1;
		return result;
	}

	public toDomain(): KimMHO {
		return {
			...this.data,
			result: this.getResult(),
			left_force_intensity: this.data.left_force_intensity ?? '',
			right_force_intensity: this.data.right_force_intensity ?? '',
			force_transfer: this.data.force_transfer ?? '',
			risk_score: this.data.risk_score ?? 0,
			risk_load: this.data.risk_load ?? ''
		};
	}
}

